<div
    class="fixed bottom-0 top-0 w-full sm:w-96 lg:sticky lg:left-full lg:h-screen lg:w-16 lg:shadow"
>
    <div
        class="bg-card flex h-full w-full flex-col transition-transform duration-400 ease-drawer sm:w-96"
        [ngClass]="{
            '-translate-x-full shadow sm:-translate-x-96 lg:-translate-x-80':
                opened,
            'translate-x-0': !opened,
        }"
    >
        <!-- Header -->
        <div
            class="quick-chat-header flex flex-0 cursor-pointer items-center justify-start"
            (click)="toggle()"
        >
            <!-- Toggle / Session list header -->
            @if (!opened || (opened && !selectedSession)) {
                <div class="flex flex-auto items-center justify-center">
                    <div class="flex w-16 flex-0 items-center justify-center">
                        <mat-icon
                            class="icon-size-6"
                            [svgIcon]="'heroicons_outline:chat-alt-2'"
                        ></mat-icon>
                    </div>
                    <div class="text-secondary text-lg font-medium">
                        Chats de Soporte
                    </div>
                    <button class="ml-auto mr-4" mat-icon-button>
                        <mat-icon
                            [svgIcon]="'heroicons_outline:x'"
                        ></mat-icon>
                    </button>
                </div>
            }

            <!-- Selected session header -->
            @if (opened && selectedSession) {
                <div class="ml-3 flex flex-auto items-center">
                    <button mat-icon-button (click)="backToList(); $event.stopPropagation()">
                        <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
                    </button>
                    <div
                        class="relative flex h-10 w-10 flex-0 items-center justify-center"
                    >
                        <div
                            class="flex h-full w-full items-center justify-center rounded-full bg-gray-200 text-lg uppercase text-gray-600 dark:bg-gray-700 dark:text-gray-200"
                        >
                            {{ selectedSession.visitorName.charAt(0) }}
                        </div>
                    </div>
                    <div class="ml-3 flex flex-col truncate">
                        <div class="truncate text-base font-medium leading-5">
                            {{ selectedSession.visitorName }}
                        </div>
                        <div class="flex items-center gap-1">
                            <span class="inline-block h-2 w-2 rounded-full" [ngClass]="getStatusClass(selectedSession.status)"></span>
                            <span class="text-xs text-secondary">{{ getStatusLabel(selectedSession.status) }}</span>
                        </div>
                    </div>
                    <!-- Actions -->
                    <div class="ml-auto mr-2 flex items-center gap-1" (click)="$event.stopPropagation()">
                        @if (selectedSession.status === 0) {
                            <button mat-icon-button matTooltip="Asignarme" (click)="assignToMe()">
                                <mat-icon [svgIcon]="'heroicons_outline:hand'"></mat-icon>
                            </button>
                        }
                        <button mat-icon-button matTooltip="Crear lead" (click)="createLeadFromChat()">
                            <mat-icon [svgIcon]="'heroicons_outline:user-add'"></mat-icon>
                        </button>
                        @if (selectedSession.status !== 2) {
                            <button mat-icon-button matTooltip="Cerrar chat" (click)="closeChat()">
                                <mat-icon [svgIcon]="'heroicons_outline:x-circle'"></mat-icon>
                            </button>
                        }
                    </div>
                </div>
            }
        </div>

        <!-- Content -->
        <div class="flex flex-auto overflow-hidden border-t">
            <!-- Session list -->
            <div
                class="h-full w-full overflow-y-auto overscroll-y-contain"
                [ngClass]="{ 'hidden': selectedSession }"
                fuseScrollbar
                [fuseScrollbarOptions]="{ wheelPropagation: false }"
            >
                <div class="flex-auto">
                    @if (sessions.length === 0) {
                        <div class="flex flex-col items-center justify-center p-8 text-center">
                            <mat-icon
                                class="icon-size-12 text-secondary"
                                [svgIcon]="'heroicons_outline:annotation'"
                            ></mat-icon>
                            <p class="text-secondary mt-2 text-sm">No hay chats activos</p>
                        </div>
                    }
                    @for (session of sessions; track trackByFn($index, session)) {
                        <div
                            class="flex cursor-pointer items-center gap-3 px-4 py-3 border-b border-gray-100 dark:border-gray-800"
                            [ngClass]="{
                                'dark:hover:bg-hover hover:bg-gray-100':
                                    !selectedSession || selectedSession.id !== session.id,
                                'bg-primary-50 dark:bg-hover':
                                    selectedSession && selectedSession.id === session.id,
                            }"
                            (click)="selectSession(session)"
                        >
                            <!-- Avatar -->
                            <div class="relative flex h-10 w-10 flex-0 items-center justify-center">
                                @if (session.unreadAdminCount > 0) {
                                    <div
                                        class="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white"
                                    >
                                        {{ session.unreadAdminCount > 9 ? '9+' : session.unreadAdminCount }}
                                    </div>
                                }
                                <div
                                    class="flex h-full w-full items-center justify-center rounded-full bg-gray-200 text-lg uppercase text-gray-600 dark:bg-gray-700 dark:text-gray-200"
                                >
                                    {{ session.visitorName.charAt(0) }}
                                </div>
                            </div>
                            <!-- Info -->
                            <div class="flex flex-auto flex-col overflow-hidden">
                                <div class="flex items-center justify-between">
                                    <span class="truncate text-sm font-medium">{{ session.visitorName }}</span>
                                    <span class="inline-block h-2 w-2 rounded-full flex-0" [ngClass]="getStatusClass(session.status)"></span>
                                </div>
                                <div class="flex items-center justify-between">
                                    <span class="text-secondary truncate text-xs">{{ session.lastMessagePreview || 'Sin mensajes' }}</span>
                                    @if (session.lastMessageAt) {
                                        <span class="text-secondary flex-0 text-[10px] ml-2">{{ session.lastMessageAt | date: 'HH:mm' }}</span>
                                    }
                                </div>
                                @if (session.isAuthenticated) {
                                    <span class="text-[10px] text-blue-500">Autenticado</span>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>

            <!-- Conversation -->
            <div
                class="flex flex-auto flex-col overflow-hidden bg-gray-50 dark:bg-transparent"
                [ngClass]="{ 'hidden': !selectedSession }"
            >
                @if (selectedSession) {
                    <div
                        class="flex flex-col-reverse overflow-y-auto overscroll-y-contain flex-auto"
                        fuseScrollbar
                        [fuseScrollbarOptions]="{ wheelPropagation: false }"
                    >
                        <div class="flex flex-auto shrink flex-col p-6">
                            @for (
                                message of messages;
                                track trackByFn(i, message);
                                let i = $index;
                                let first = $first;
                                let last = $last
                            ) {
                                <!-- Start of the day -->
                                @if (
                                    first ||
                                    (messages[i - 1].sentAt | date: 'd') !== (message.sentAt | date: 'd')
                                ) {
                                    <div class="-mx-6 my-3 flex items-center justify-center">
                                        <div class="flex-auto border-b"></div>
                                        <div class="text-secondary mx-4 flex-0 text-sm font-medium leading-5">
                                            {{ message.sentAt | date: 'longDate' }}
                                        </div>
                                        <div class="flex-auto border-b"></div>
                                    </div>
                                }
                                <div
                                    class="flex flex-col"
                                    [ngClass]="{
                                        'items-end': message.senderType === 'admin',
                                        'items-start': message.senderType !== 'admin',
                                        'mt-0.5':
                                            i > 0 &&
                                            messages[i - 1].senderType === message.senderType,
                                        'mt-3':
                                            i > 0 &&
                                            messages[i - 1].senderType !== message.senderType,
                                    }"
                                >
                                    <!-- Sender name for visitor messages -->
                                    @if (message.senderType === 'visitor' && (first || messages[i - 1].senderType !== 'visitor')) {
                                        <div class="text-xs text-secondary ml-3 mb-0.5">{{ message.senderName }}</div>
                                    }
                                    <!-- Bubble -->
                                    <div
                                        class="relative max-w-3/4 rounded-lg px-3 py-2"
                                        [ngClass]="{
                                            'bg-blue-500 text-blue-50': message.senderType === 'admin',
                                            'bg-gray-500 text-gray-50': message.senderType !== 'admin',
                                        }"
                                    >
                                        <!-- Speech bubble tail -->
                                        @if (
                                            last || messages[i + 1].senderType !== message.senderType
                                        ) {
                                            <div
                                                class="absolute bottom-0 w-3"
                                                [ngClass]="{
                                                    '-right-1 -mr-px mb-px text-blue-500': message.senderType === 'admin',
                                                    '-left-1 -ml-px mb-px -scale-x-1 text-gray-500': message.senderType !== 'admin',
                                                }"
                                            >
                                                <ng-container *ngTemplateOutlet="speechBubbleExtension"></ng-container>
                                            </div>
                                        }
                                        <!-- Message -->
                                        <div class="min-w-4 leading-5" [innerHTML]="linkify(message.content)"></div>
                                    </div>
                                    <!-- Time -->
                                    @if (
                                        first || last ||
                                        messages[i + 1].senderType !== message.senderType
                                    ) {
                                        <div
                                            class="text-secondary my-0.5 text-sm font-medium"
                                            [ngClass]="{
                                                'mr-3': message.senderType === 'admin',
                                                'ml-3': message.senderType !== 'admin',
                                            }"
                                        >
                                            {{ message.sentAt | date: 'HH:mm' }}
                                        </div>
                                    }
                                </div>
                            }

                            <!-- Typing indicator -->
                            @if (visitorTyping) {
                                <div class="flex items-start mt-2">
                                    <div class="bg-gray-500 text-gray-50 rounded-lg px-3 py-2">
                                        <div class="flex items-center gap-1">
                                            <div class="w-1.5 h-1.5 bg-gray-300 rounded-full animate-bounce" style="animation-delay: 0ms"></div>
                                            <div class="w-1.5 h-1.5 bg-gray-300 rounded-full animate-bounce" style="animation-delay: 150ms"></div>
                                            <div class="w-1.5 h-1.5 bg-gray-300 rounded-full animate-bounce" style="animation-delay: 300ms"></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- Message field -->
                    <div class="flex items-end border-t bg-gray-50 p-4 dark:bg-transparent">
                        <mat-form-field
                            class="fuse-mat-dense fuse-mat-rounded fuse-mat-bold w-full"
                            [subscriptSizing]="'dynamic'"
                        >
                            <textarea
                                matInput
                                cdkTextareaAutosize
                                #messageInput
                                placeholder="Escribe un mensaje..."
                                (keydown)="onInputKeydown($event)"
                                (input)="onInputChange()"
                            ></textarea>
                        </mat-form-field>
                        <div class="my-px ml-4 flex h-11 items-center">
                            <button mat-icon-button (click)="sendMessage()">
                                <mat-icon
                                    [svgIcon]="'heroicons_outline:paper-airplane'"
                                ></mat-icon>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>

<!-- Speech bubble tail SVG -->
<!-- prettier-ignore -->
<ng-template #speechBubbleExtension>
    <svg width="100%" height="100%" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M1.01522827,0.516204834 C-8.83532715,54.3062744 61.7609863,70.5215302 64.8009949,64.3061218 C68.8074951,54.8859711 30.1663208,52.9997559 37.5036011,0.516204834 L1.01522827,0.516204834 Z" fill="currentColor" fill-rule="nonzero"></path>
        </g>
    </svg>
</ng-template>
